import { makeReference, useApolloClient } from '@apollo/client';
import { logError } from '@infl-ts/util-query-errors';
import { ChallengePlayerContext, removeCPSearchParam } from '@infl-ts/util-use-challenge-player';
import { useMediaQuery } from '@mui/material';
import * as DE from '@nll/datum/lib/DatumEither';
import { flow, pipe } from 'fp-ts/function';
import { useCallback, useContext } from 'react';
import { ChallengeBar, ChallengeBarError, ChallengeBarSkeleton } from './challenge-bar';
import { jsx as _jsx } from "react/jsx-runtime";

var determineActivityToOpen = function determineActivityToOpen(activityId) {
  return activityId !== 'new' ? activityId : undefined;
};

export var ChallengeBarWrapper = function ChallengeBarWrapper(_ref) {
  var challengeData = _ref.challengeData;

  var _useContext = useContext(ChallengePlayerContext),
      manuallyOpenChallengePlayer = _useContext.manuallyOpenChallengePlayer,
      _useContext$challenge = _useContext.challengePlayerState,
      activity = _useContext$challenge.activity,
      stage = _useContext$challenge.stage;

  var _useApolloClient = useApolloClient(),
      cache = _useApolloClient.cache;

  var isMobile = useMediaQuery(function (theme) {
    return theme.breakpoints.down('md');
  });
  var handleOpenChallenge = useCallback(function (challengeId) {
    var _activity$id;

    cache.evict({
      id: cache.identify(makeReference("Challenge:".concat(challengeId)))
    });
    removeCPSearchParam('minimized');
    manuallyOpenChallengePlayer({
      uuid: challengeId,
      minimized: false,
      activity: determineActivityToOpen((_activity$id = activity === null || activity === void 0 ? void 0 : activity.id) !== null && _activity$id !== void 0 ? _activity$id : 'new')
    });
  }, [activity, cache, manuallyOpenChallengePlayer]);
  return pipe(challengeData, DE.refreshFold(function () {
    return /*#__PURE__*/_jsx(ChallengeBarSkeleton, {
      isMobile: isMobile
    });
  }, function () {
    return /*#__PURE__*/_jsx(ChallengeBarSkeleton, {
      isMobile: isMobile
    });
  }, flow(logError, function () {
    return /*#__PURE__*/_jsx(ChallengeBarError, {
      isMobile: isMobile
    });
  }), function (_ref2) {
    var _stage$points;

    var challenge = _ref2.challenge;
    return /*#__PURE__*/_jsx(ChallengeBar, {
      challenge: challenge,
      stageType: stage === null || stage === void 0 ? void 0 : stage.__typename,
      points: (_stage$points = stage === null || stage === void 0 ? void 0 : stage.points) !== null && _stage$points !== void 0 ? _stage$points : 0,
      handleOpenChallenge: handleOpenChallenge
    });
  }));
};